export const clientListSelector = (state: RootState) => state.client.clients;
export const loadingClientQuerySelector = (state: RootState) => state.client.loadingQuery;
export const creatingClientSelector = (state: RootState) => state.client.creatingClient;
export const updatingClientSelector = (state: RootState) => state.client.updatingClient;
export const deletingClientSelector = (state: RootState) => state.client.deletingClient;
export const deleteSuccessSelector = (state: RootState) => state.client.deleteSuccess;
export const saveSuccessSelector = (state: RootState) => state.client.saveSuccess;
export const createFailureSelector = (state: RootState) => state.client.createFailed;